import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import {Button, Modal, ModalBody, Input, ModalFooter, ModalHeader} from "reactstrap";
import "../assets/css/monthpicker/month-picker.css";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import { List } from 'react-virtualized';
import ModalD from "react-awesome-modal";
import DatePicker from "react-datepicker";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthOptions = [];
var monthOptions_task = [];
for(var i=0; i<=23; i++){
    let date2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    //console.log("currDate"); console.log(date2);
    let monthd = date2.setMonth(date2.getMonth() -i);
    date2 = date2.toDateString();
    date2 = new Date(date2);
    let month2 = getMonth(date2);
    let year2 = date2.getFullYear();
    let monthName2 = monthNames[date2.getMonth()];
    var isDisable = true;
    if(month2 == '06' || month2 == '07'){
        isDisable = false;
    }
    monthOptions.push({ value: month2+'_'+year2, label: monthName2+' '+year2});
    if(i>=12) {
        monthOptions_task.push({ value: month2+year2, label: monthName2+' '+year2})
    }

}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var tod1 = moment(todayDate).format('MM/DD/YYYY');
var yest1 = moment(yesterday).format('MM/DD/YYYY');
var todShow1 = moment(todayDate).format('D MMM YYYY');
var yestShow1 = moment(yesterday).format('D MMM YYYY');
var todSend1 = moment(todayDate).format('YYYY-MM-DD');
var yestSend1 = moment(yesterday).format('YYYY-MM-DD');


var date_limit = moment(todayDate).format('MM/DD/YYYY');
class SchedularReportPage extends Component{
    constructor(props) {
        super(props);
        this.state = {
            feq_name_list:[],
            month_year:monthOptions[0+12].value,
            frequency_id:2,
            config_report_data:[],
            newRiseModel: false,
            newIssueModel: false,
            newErrorModel: false,
            loading:true,
            merchantList:[{value:'', label: 'All'}],
            chainList:[{value:'', label: 'All'}],
            merchantID:[],
            chainID:[],
            storeID:[],
            storeList:[{value:'', label: 'All'}],
            mvalue: {year: new Date().getFullYear(), month: 11},
            month_year_task:monthOptions_task[0].value,
            arg_type: 'Merchant',
            acq_bank_list:[{value:'', label: 'All'}],
            time_list:[{value:'00', label: '00'},{value:'01', label: '01'},{value:'02', label: '02'},{value:'03', label: '03'},{value:'04', label: '04'},{value:'05', label: '05'},{value:'06', label: '06'},{value:'07', label: '07'},{value:'08', label: '08'},{value:'09', label: '09'},{value:'10', label: '10'},{value:'11', label: '11'},{value:'12', label: '12'},
                {value:'13', label: '13'},{value:'14', label: '14'},{value:'15', label: '15'},{value:'16', label: '16'},{value:'17', label: '17'},{value:'18', label: '18'},{value:'19', label: '19'},{value:'20', label: '20'},{value:'21', label: '21'},{value:'22', label: '23'},{value:'24', label: '24'}
            ],
            acq_bank_id:[],
            feq_id:'',
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            dateTo1:tod,
            dateToShow1:todShow,
            todSend1:todSend,
            yestSend1:yestSend,
            datefrom1:yest,
            datefromShow1:yestShow,
            task_identifier: '',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds: [],
            force_run: 0,
            error_data: [],
            etype: '',
            sch_time:"00",
            recipients:[{email:"", email_type:"", receiver_type:""}],
            report_name:"",
            script_name:"",
            task_dep_list:[],
            task_dep_name:[],
            task_dep_value:'',
            task_identifier1:'',
            same_time_run:'',
            comments:""
        };
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({email:decoded.email});
        this.get_frequency();
        this.get_task_dependencies();
        // this.get_all_acq_bank();
        this.get_process_log();
        this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend);
        // this._getAllMerchants();
        // this._get_issuing_banks();
        // this.interval = setInterval(() => {
        //     this.get_process_log(this.state.frequency_id, this.state.month_year);
        // }, 30000);
    }
    get_all_acq_bank() {
        axios.get(config.get('API_URL')+'/invoice/all_acq_banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(response.data.data != null) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acq_bank_list.push({value: response.data.data[key], label: key})
                });
            }
        });
    }

    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) { // alert(value); alert(text);
        this.setState({
            mvalue: {year: value, month: text}
        });
        //this.refs.pickAMonth.hide()
        this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            response.data.map((merchant,index) => {
                this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
        });
    }
    changeMerchant(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        let midArray = [];
        midArray.push(value)
        this.setState({
            merchantID:midArray,
            chainID: [],
            merchantValue:optionSelected,
            chainValue:null
        });
        axios.post(config.get('API_URL')+'/invoice/chains_by_merchant_code/',{
                code: value,
             },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [{value:'', label: 'All'}];
            this.setState({chainID: []});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    changeChain(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        let cidArray = [];
        cidArray.push(value)
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected
        });
        axios.post(config.get('API_URL')+'/invoice/store_by_chain_code/', {
                code: value,

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
        }).then(response => { //console.log(response);
            let storeList = [{value:'', label: 'All'}];
            this.setState({storeID: []});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        let sidArray = [];
        sidArray.push(value)
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
    }
    _get_issuing_banks() {
        this.setState({
            acq_loading: true
        })
        axios.get(config.get('API_URL')+'/reports/get-issuing-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuing_bank_name, label: issuBank.issuing_bank_name})
                });
            }
            this.setState({
                acq_loading: false
            })
        });

    }
    change_issuer(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            issuerBankIds: value,
            issuerBankValue:optionSelected
        });
    }

    toggleNewStartModel(key,id, e) {
        this.setState({
            newRiseModel: !this.state.newRiseModel,
            feq_id:id,
            task_identifier: key
        })
    }
    toggleNewIssueModel(e, issue) {
        this.setState({
            newIssueModel: !this.state.newIssueModel,
            issue: issue
        })
    }

    toggleNewErrorModel(data) {
        this.setState({
            newErrorModel: true,
            error_data: data
        })
    }

    closeModal() {
        this.setState({
            newErrorModel: false
        });
    }

    closeModalAndRun() {
        this.handleClickRerunTask(1, 'manual');
        this.setState({
            newErrorModel: false
        });
    }
    get_task_schedule(frequency_id, from, to) {
        this.setState({
            loading: true
        });
        if ($.fn.DataTable.isDataTable('#configReportTable')) {
            $('#configReportTable').DataTable().destroy();
        }
        // const fields = month.split('_');
        // const monthval = fields[0];
        // const yearval = fields[1];
         axios.get(config.get('API_URL')+'/schedulereport/configure-reports/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
             params:{
                 frequency_id:frequency_id,
                 from:from,
                 to:to,
             }
        }).then(response => {
            console.log(response);
             if (Array.isArray(response.data.data) && response.data.data.length) {
                 this.setState({
                     config_report_data: response.data.data,
                     loading:false
                 });
             } else {
                 this.setState({
                     loading:false
                 })
             }
             $('#configReportTable').DataTable({
                 "scrollX": true
             });

        }).catch( err => {
            console.log(err);
        });
    }

    startScript(id,e){
        //e.preventDefault();
        confirmAlert({
            title: 'Question',
            message: 'Are you sure to start report',
            buttons: [{
                label: 'Yes',
                // onClick: () => {
                //     this.handleClickRerun(id);
                // }
            },
                {
                    label: 'No',
                }
            ]
        });
    }

    stopScript(e, rowData){
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'Are you sure to stop report',
            buttons: [{
                label: 'Yes',
                // onClick: () => {
                //     this.handleClickStopProcess(rowData.task_schedule_id, rowData.task_run_id);
                // }
            },
                {
                    label: 'No',
                }
            ]
        });

    }
    handleClickStopProcess(id,rid){
        axios.get(config.get('API_URL')+'/invoice/stop_process_log_one/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                task_run_id:rid,
                email: this.state.email
            }
        }).then(response => {
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend);
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend);
        }).catch( err => {
            console.log(err);
        });
    }
    stopSchedule(id,e){
        e.preventDefault();
        confirmAlert({
            title: 'Question',
            message: 'Are you sure, you want to stop this task',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleStopSchedule(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }
    handleStopSchedule(id){
        axios.get(config.get('API_URL')+'/invoice/stop_process_log/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                email: this.state.email
            }
        }).then(response => {
            this.get_task_schedule(this.state.frequency_id, this.state.month_year);
        }).catch( err => {
            console.log(err);
        });
    }
    get_process_log(frequency_id, from, to) {
        // const fields = month.split('_');
        // const monthval = fields[0];
        // const yearval = fields[1];
        var postData = {

        }
        if ($.fn.DataTable.isDataTable('#logTable')) {
            $('#logTable').DataTable().clear().destroy();
        }
        var logTable = $('#logTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 10,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": true,
                //"dom": '<"top"lf>t<"bottom"pi><"clear">',
                "searching": true,
                //"lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/schedulereport/configure-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {  console.log(json.data);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

        columns: [
                    {"data":"Report Name"},
                    {"data":"Script Name"},
                    {"data":"Scheduled By"},
                    {"data":"Frequency"},
                    {"data":"Email Group"},
                    {"data":"Email Type"},
                    {"data":"Last Run At"},
                    {"data":"Last Run Status"},

                ],
                "columnDefs": [
                    {
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                        //console.log(td);
                            if (rowData.status == 'success') {
                                $(td).addClass('doneLog');
                            }
                            if (rowData.status == 'running') {
                                $(td).addClass('ongoingLog');
                            }
                            if (rowData.status == 'failed') {
                                $(td).addClass('failedLog');
                            }
                            if (rowData.status == 'stopped') {
                                $(td).addClass('stopedLog');
                            }
                        },
                    },
                //     {
                //
                //         "className":"text-center",
                //         "targets": 7,
                //         "data": "data",
                //         "createdCell": (td, cellData, rowData, row, col) => {
                //             $(td).text('');
                //
                //             if(rowData.issues==null || rowData.issues=='null' || rowData.issues=='') {
                //                 $(td).text('');
                //
                //             }
                //             else {
                //                 var n = rowData.issues.length;
                //                 if (n > 50) {
                //                     var trimmedString = rowData.issues.substring(0, 50);
                //                     $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View More..</a>');
                //                     $(td).click(e => {
                //                         this.toggleNewIssueModel(e, rowData.issues);
                //                     })
                //                 } else {
                //                     $(td).append(rowData.issues );
                //
                //                 }
                //             }
                //         },
                //         bSortable: false,
                //     },
                //     {
                //         render: function (data, type, row) {
                //
                //             return '<td><a href="#" data-toggle="tooltip" title='+JSON.stringify(data)+'><i class="fa fa-info-circle" aria-hidden="true"></i></a></td>';
                //
                //         },
                //
                //         className: "",
                //         targets: 8,
                //         aTargets: [-1]
                //     },
                //     {
                //     "width": "50px",
                //      "className":"text-center",
                //     "targets": 9,
                //     "data": "data",
                //     "createdCell": (td, cellData, rowData, row, col) => {
                //         $(td).text('');
                //         if(rowData.Status=='running') {
                //             $(td).append('<a href="#"  data-tip="Stop" title="Stop" id="Stop"  class="stopButton" >Stop</a>');
                //             $(td).click(e => {
                //                 this.stop_process(e,rowData);
                //             })
                //         }
                //         else {
                //             $(td).append('<a href="#"  data-tip="Re Run" title="Re Run" id="re_run"  class="RerunButton" >Rerun</a>');
                //             $(td).click(e => {
                //                 this.re_run(e,rowData);
                //             })
                //         }
                //     },
                //     bSortable: false,
                // }
                ]

            });
    }
    re_run(e, rowData){
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'Are you sure, you want to re-run this task',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickRerun(rowData.task_schedule_id, rowData.task_run_id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }

    handleClickRerunTask(forceRun, run_type, e) {

        if (forceRun == 1) {
            forceRun = 1
        } else {
            forceRun = 0
        }
        // alert(forceRun)
        //alert(this.state.merchantID); alert(this.state.chainID); alert(this.state.storeID);
    //alert(this.state.arg_type);
        //$("#logTable_processing").css("display", "block");
        var fields = this.state.todSend.split('-');
        var year = fields[0];
        var month = fields[1];
        var day = fields[2];
        var run_at = {day:day, month:month, year:year, hour:this.state.sch_time }

        axios.post(config.get('API_URL')+'/schedulereport/schedule-new-script/',{
                task_name: this.state.report_name,
                task_frequency_id: this.state.frequency_id,
                user_email: this.state.email,
                script_name: this.state.script_name,
                scheduled_by: this.state.email,
                run_at: run_at,
                same_time_run: this.state.same_time_run,
                task_identifier1: this.state.task_identifier1,
                task_dependencies: this.state.task_dep_name,
                comments: "",
                recipients: this.state.recipients
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {
            // console.log(response);
            // console.log(response.data.extra_data.error)
            if (response.data.extra_data.error === 'failed-tasks') {
                var array = response.data.extra_data.tasks
                var ts = array.join(', ');
                //console.log(ts);
                this.setState({
                    force_run: 1,
                    etype: response.data.extra_data.error,
                    tasks_lists: ts
                })
                this.toggleNewErrorModel(response.data);
            }
            if(response.data.error){
                this.props.handleClick("tr", 3, response.data.error);
            }
            else {

            }


        }).catch( err => {
            console.log(err);
        });
        this.setState({
            newRiseModel: false
        })
    }

    handleClickRerun(id, rid){ //alert(id); alert(this.state.email);
        //$("#logTable_processing").css("display", "block");
        //alert(rid);
        axios.get(config.get('API_URL')+'/invoice/rerun_process_log/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                task_run_id: rid,
                email: this.state.email
            }
        }).then(response => {
            //console.log(response);
           // $("#logTable_processing").css("display", "none");
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend);
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend);

        }).catch( err => {
            console.log(err);
        });
    }
    get_task_dependencies(){
        axios.get(config.get('API_URL')+'/schedulereport/task_dependencies/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            response.data.data.map((dep,index) => {
                this.state.task_dep_list.push({value: dep.task_identifier, label: dep.task_identifier})
            });

        }).catch( err => {
            console.log(err);
        });
    }
    get_frequency(val){
        axios.get(config.get('API_URL')+'/invoice/get_frequency_name/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        //console.log(response);
            response.data.map((frequency,index) => {
                this.state.feq_name_list.push({value: frequency.task_frequency_id, label: frequency.frequency_name})
            });

        }).catch( err => {
            console.log(err);
        });
    }
    changeMonth(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        //alert(value);
        this.setState({
            month_year: value
        });


    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend);
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend);
            // this._get_filtered_eod_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs)
        }

    }





    changeMonth_task(event, picker, e) {
       //  const value = optionSelected === null ? '' : optionSelected.value;
       // // alert(value);
       //  this.setState({
       //      month_year_task: value
       //  });

        this.setState({
            todSend1: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend1: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow1: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow1: moment(picker.endDate).format('D MMM YYYY')
        });

    }
    changeFrequency(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            frequency_id: value
        });
        // this.get_process_log(value, this.state.yestSend, this.state.todSend);
        // this.get_task_schedule(value, this.state.yestSend, this.state.todSend);
    }
    changeTime(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        // alert(value);
        this.setState({
            sch_time: value
        });
        // this.get_process_log(value, this.state.yestSend, this.state.todSend);
        // this.get_task_schedule(value, this.state.yestSend, this.state.todSend);
    }
    onTypeChanged(e){
        this.setState({
            arg_type:e.target.value
        });
        if(e.target.value=='Acquiring_Bank'){
            this.setState({
                merchantID: [],
                chainID: []
            })
        }

        if(e.target.value=='Issuing_Bank'){
            this.setState({
                merchantID: [],
                chainID: []
            })
        }
    }
    changeBank(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            acq_bank_id: value
        })
    }

    run_all(e) {
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'This will start all tasks which are applicable to run. Are you sure, you want to do this',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickRerunTask(1, 'automated')
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }
    handleFromChange = date => { //alert(date);
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            todSend: date_filter
        });

    };
    handleRemoveMinKey = idx => (e) => {
        e.preventDefault();

        this.setState({
            recipients: this.state.recipients.filter((s, sidx) => idx !== sidx)
        });
    }
    handleAddMinKey(idx, arrayLenght, e) {
        e.preventDefault();
        var obLabel = (arrayLenght+10).toString(36);
        this.setState({
            recipients: this.state.recipients.concat([{email:"", email_type:"", receiver_type:""}])
        });
        //this.get_object_stage(1,1)
    }
    onChangeInput(e){
        this.setState({ [e.target.name]: e.target.value });
    }
    changeEmail(idx, e){
        const pemail = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, email: e.target.value };
        });
        this.setState({ recipients: pemail });
    }
    changeEmailType(idx, e){
        const pemail_type = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, email_type: e.target.value };
        });
        this.setState({ recipients: pemail_type });
    }
    changeReceiverType(idx, e){
        const pReceiverType = this.state.recipients.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, receiver_type: e.target.value };
        });
        this.setState({ recipients: pReceiverType });
    }
    changeTaskDependancy(optionSelected){
        let value='';
        let depArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((dep, i) => {
                depArray.push(dep.value)
            });
        }

        this.setState({
            task_dep_value: optionSelected,
            task_dep_name: depArray
        });

        // axios.get(config.get('API_URL')+'/masterdata/get_gst_code/',{
        //     headers: {
        //         Authorization: ` ${localStorage.usertoken}`
        //     },
        //     params: {
        //         gst: value
        //     }
        // }).then(response => {
        //     this.setState({
        //         gst_code: response.data.gst_code
        //     });
        //
        // })
    }
    changeSameTimeRun(e){
       //alert(e.target.value);
        this.setState({ same_time_run: e.target.value });
    }
    render() {
        console.log(this.state.recipients);
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "34px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 }),

        };

        let taskTableData = this.state.config_report_data.map((val,index) => {  console.log(val["Script Name"]);
            return (
                <tr key={index + 1}>
                    <td>{val["Report Name"]}</td>
                    <td>{val["Script Name"]}</td>
                    <td>{val["Scheduled By"]}</td>
                    <td>{val["Frequency"]}</td>
                    <td>{val["Email Group"]}</td>
                    <td>{val["Email Type"]}</td>
                    <td>{val["Last Run At"]}</td>
                    <td>{val["Last Run Status"]}</td>
                    <td className="text-center">
                        {/*<ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>*/}
                        <a href="#" onClick={this.startScript.bind(this)} data-tip="Start"   className="startButton">Start</a>
                    </td>
                    <td className="text-center">
                        {/*<ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>*/}
                        <a href="#" onClick={this.stopScript.bind(this)} data-tip="Stop"   className="stopButton">Stop</a>
                    </td>
                </tr>
            )
        });
        return(


            <div className="content">

                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <NotificationSystem ref="notificationSystem" style={style}/>
                                <div className="content">
                                    <div className="row">
                                        <NotificationSystem ref="notificationSystem" style={style} />
                                        <div className="col-md-12">
                                            {/*<div className="col-md-3 ">*/}
                                            {/*    <label> Frequency </label>*/}
                                            {/*    <Select name="Frequency"*/}
                                            {/*            styles={customStyles} className="chainLists"*/}
                                            {/*            isClearable={false}*/}
                                            {/*            onChange={this.changeFrequency.bind(this)}*/}
                                            {/*            options={this.state.feq_name_list}*/}
                                            {/*            defaultValue={{ label: "Daily", value: 2 }}*/}
                                            {/*            placeholder="Frequency"*/}
                                            {/*    />*/}
                                            {/*    <div className="clearfix"></div>*/}
                                            {/*</div>*/}
                                            <div className="col-md-3 ">

                                                {/*<label> Date Filter </label>*/}
                                                {/*<DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}*/}
                                                {/*                 onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>*/}
                                                {/*    <i className="fa fa-calendar" aria-hidden="true"></i>*/}
                                                {/*    <input type="text" name="dateRange" className="form-control dateRangeInput"*/}
                                                {/*           value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>*/}
                                                {/*</DateRangePicker>*/}
                                                {/*<Select name="month"*/}
                                                {/*        styles={customStyles} className="chainLists"*/}
                                                {/*        isClearable={false}*/}
                                                {/*        onChange={this.changeMonth.bind(this)}*/}
                                                {/*        options={monthOptions}*/}
                                                {/*        defaultValue={monthOptions[12]}*/}
                                                {/*        placeholder="Months"*/}
                                                {/*/>*/}
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*<div className="col-md-2 pull-right top-margin-30">*/}
                                            {/*    <Button color="primary run-all-task"*/}
                                            {/*            onClick={this.run_all.bind(this)}>Run*/}
                                            {/*        All</Button>*/}
                                            {/*</div>*/}

                                        </div>
                                    </div>
                                </div>
                                <hr className="m-0 p-0"/>
                                <div className="clearfix"></div>

                                <div className="content table-full-width table-responsive nomargin">
                                    <div className="col-md-6">
                                        <div className="header">
                                            <h4 className="title">Report Master</h4>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="col-md-6 col-xs-6"></div>
                                        <div className="col-md-6 col-xs-6 addIcon">
                                            <a href="#" className="addButton" role="button"
                                               onClick={this.toggleNewStartModel.bind(this, 'Add')}>
                                                {/* <span
                                            className="glyphicon glyphicon-plus" aria-hidden="true"></span> */}
                                                Schedule New Script</a>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <table id="configReportTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>Report Name</th>
                                            <th>Script Name</th>
                                            <th>Scheduled By</th>
                                            <th>Frequency</th>
                                            <th>Email Group</th>
                                            <th>Email Type</th>
                                            <th>Last Run At</th>
                                            <th>Last Run Status</th>
                                            <th className="text-center">Start</th>
                                            <th className="text-center">Stop</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {taskTableData}
                                        </tbody>

                                    </table>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                    <hr/>
                                    {/*<div className="header">*/}
                                    {/*    <h4 className="title">Report Master</h4>*/}
                                    {/*</div>*/}
                                    {/*<table id="logTable" className="table table-striped table-hover">*/}
                                    {/*    <thead>*/}
                                    {/*    <tr>*/}
                                    {/*        <th>Report Name</th>*/}
                                    {/*        <th>Script Name</th>*/}
                                    {/*        <th>Scheduled By</th>*/}
                                    {/*        <th>Frequency</th>*/}
                                    {/*        <th>Email Group</th>*/}
                                    {/*        <th>Email Type</th>*/}
                                    {/*        <th>Last Run At</th>*/}
                                    {/*        <th>Last Run Status</th>*/}

                                    {/*    </tr>*/}
                                    {/*    </thead>*/}
                                    {/*</table>*/}
                                </div>
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal isOpen={this.state.newRiseModel} toggle={this.toggleNewStartModel.bind(this)} >
                    <ModalHeader toggle={this.toggleNewStartModel.bind(this)}>Schedule New Script</ModalHeader>
                    <ModalBody>
                        <div className="">
                                <div>
                                    <div className="col-md-6">
                                        <label>Report Name</label>
                                        <Input id="reporter" name="report_name" value={this.state.report_name} onChange={this.onChangeInput.bind(this)}   />

                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-6">
                                        <label> Script Name </label>
                                        <Input id="reporter" name="script_name"  value={this.state.script_name} onChange={this.onChangeInput.bind(this)}   />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-6">
                                        <label> Frequency </label>
                                        <Select name="Frequency"
                                           styles={customStyles} className="chainLists"
                                            isClearable={false}
                                            onChange={this.changeFrequency.bind(this)}
                                            options={this.state.feq_name_list}
                                            defaultValue={{ label: "Daily", value: 2 }}
                                            placeholder="Frequency"
                                           />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2">
                                        <label> Date </label>
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            selected={Date.parse(this.state.todSend)}
                                            onChange={this.handleFromChange}
                                            // minDate={yesterday}
                                            maxDate={todayDate}
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2">
                                        <label>Time</label>
                                        <Select name="sch_time"
                                                styles={customStyles} className="chainLists"
                                                isClearable={false}
                                                onChange={this.changeTime.bind(this)}
                                                options={this.state.time_list}
                                                defaultValue={{ label: "00", value: "00" }}
                                                placeholder="Time"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-6">
                                        <label>Task identifier</label>
                                        <Input id="reporter" name="task_identifier1" value={this.state.task_identifier1} onChange={this.onChangeInput.bind(this)}   />

                                        <div className="clearfix"></div>
                                    </div>


                                    <div className="col-md-6">
                                        <label> Task Dependencies </label>

                                        <ReactMultiSelectCheckboxes name="gst"
                                            value={this.state.task_dep_value}
                                            styles={customStyles} className="partyNameList"
                                            isClearable={false}
                                            onChange={this.changeTaskDependancy.bind(this)}
                                            options={this.state.task_dep_list}
                    //defaultValue={{ label: "All", value: '' }}
                                            placeholderButtonLabel="All"
                                            // placeholder="All"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="col-md-12">
                                        <label>Same time run &nbsp; &nbsp; &nbsp; &nbsp;</label>
                                        <input type="radio" name="same_time_run" value="true"
                                               onChange={this.changeSameTimeRun.bind(this)} /> True &nbsp;
                                        <input type="radio" name="same_time_run" value="false"
                                               onChange={this.changeSameTimeRun.bind(this)} /> False &nbsp;
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="">
                                        {this.state.recipients.map((recipients, idx) => (
                                            <div className="recipients-container" key={idx+1}>
                                                {/*<div>*/}
                                                <div className="col-md-1 padd-2">
                                                    {idx==0?<div className=""><label>&nbsp;</label></div>:null}
                                                    <div className="Rule-al">
                                                        {idx>0?
                                                            <a href="#" onClick={this.handleRemoveMinKey(idx,this)}
                                                               className="addmore_rulesp"
                                                            ><i className="fa fa-trash" aria-hidden="true"></i>
                                                            </a>:<a href="#" onClick={this.handleAddMinKey.bind(this, idx+1, this.state.recipients.length)}
                                                                    className="addmore_rulesp-plus"
                                                            ><span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                            </a>}

                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    {idx==0?<label> Email </label>:null}
                                                    {/*<Input id="email" name="email"  />*/}
                                                    <input type="text" value={recipients.email} name="email" className="form-control" onChange={this.changeEmail.bind(this, idx)}/>
                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="col-md-3">
                                                    {idx==0?<label> Email Type </label>:null}
                                                    {/*<Input id="reporter" name="reporter"  />*/}
                                                    <input type="text" value={recipients.email_type} name="email_type" className="form-control" onChange={this.changeEmailType.bind(this, idx)}/>
                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="col-md-3">
                                                    {idx==0?<label> Receiver Type </label>:null}
                                                    {/*<Input id="reporter" name="reporter"  />*/}
                                                    <input type="text" value={recipients.receiver_type} name="receiver_type" className="form-control" onChange={this.changeReceiverType.bind(this, idx)}/>
                                                    <div className="clearfix"></div>

                                                </div>
                                                <div className="clearfix"></div>
                                            </div>))}
                                    </div>
                                    <div className="col-md-12">
                                        <label> Comments </label>
                                        <textarea name = "comments" rows="3" placeholder="" id="formControlsTextarea" onChange={this.onChangeInput.bind(this)}
                                                  className="form-control pricingDescription" value={this.state.des_content}>
                                        </textarea>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>


                            <div className="clearfix"></div>

                            {/*<div className="content-tdetails-table table-full-width table-responsive">*/}
                            {/*    <table id="EmiSchemeTable" className="table table-striped table-hover">*/}

                            {/*    </table>*/}
                            {/*</div>*/}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary"
                                onClick={this.handleClickRerunTask.bind(this, 0, 'manual')} >Submit</Button>{' '}
                        <Button color="secondary" onClick={this.toggleNewStartModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                    <Modal isOpen={this.state.newIssueModel} toggle={this.toggleNewIssueModel.bind(this)} >
                        <ModalHeader toggle={this.toggleNewIssueModel.bind(this)}>Issue Details</ModalHeader>
                        <ModalBody>
                            <div className="issue_container">
                                {this.state.issue}
                            </div>
                        </ModalBody>
                        <ModalFooter>

                            <Button color="secondary" onClick={this.toggleNewIssueModel.bind(this)}>Cancel</Button>
                        </ModalFooter>
                    </Modal>

                    <ModalD visible={this.state.newErrorModel} width="300" height="100" effect="fadeInUp">
                        <div className="download-popup-model">
                            <div className="log-message-content">
                                {this.state.ts != '' ?
                                    <div>Tasks: {this.state.tasks_lists}</div> : null
                                }
                                {this.state.etype == 'failed-tasks' ?
                                    <React.Fragment>
                                        Force to run?
                                        <div className="col-md-12 pull-right">
                                            <a href="javascript:void(0);" onClick={() => this.closeModal()}
                                               className="log-btn-sure">
                                                No
                                            </a>
                                            <a href="javascript:void(0);" onClick={() => this.closeModalAndRun()}
                                               className="log-btn-sure">
                                                Yes
                                            </a>

                                        </div>
                                    </React.Fragment> : null}
                                {this.state.etype == 'running-tasks' ?
                                    <React.Fragment>
                                        Running
                                    </React.Fragment> : null}
                            </div>
                        </div>
                    </ModalD>
                </div>
            </div>
        );
    }
}

export default SchedularReportPage